import { createTheme } from '@mui/material/styles';

export const allianzTheme = createTheme({
  palette: {
    primary: {
      main: '#003781',
      light: 'rgba(0, 55, 129, 0.1)',
      dark: 'rgba(0, 55, 129, 0.9)',
      contrastText: '#fff',
    },
    secondary: {
      main: '#E5E5E5',
      light: '#f2f2f2',
      dark: '#C4C4C4',
      contrastText: '#414141',
    },
    error: {
      main: '#D41010',
      light: '#e57373',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      main: '#FFAC00',
      light: '#FFF6E4',
      dark: '#f57c00',
      contrastText: '#414141',
    },
    info: {
      main: '#207BD0',
      light: 'rgba(233, 242, 250, 0.1)',
      dark: '#136fad',
      contrastText: '#fff',
    },
    success: {
      main: '#4499AE',
      light: 'rgba(224, 235, 239, 0.1)',
      dark: '#90B9C9',
      contrastText: '#545454',
    },
    grey: {
      50: '#F0F0F0',
      100: '#f2f2f2',
      200: '#C6C3C7',
      300: '#E5E5E5',
      400: '#B3B3B3',
      500: '#C4C4C4',
      600: '#C6C3C7',
      700: '#707070',
      800: '#424242',
      900: '#050505',
    },
    text: {
      primary: '#545454',
      secondary: '#414141',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"AllianzNeo", Helvetica, Arial, sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.25rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.125rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '.95rem',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: '40px',
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: 'rgb(39,62,107)',
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 400,
          paddingTop: '6px',
          paddingBottom: '6px',
          paddingLeft: '20px',
          paddingRight: '20px',
          '&.Mui-selected': {
            backgroundColor: '#003781',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#003781',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          marginRight: '8px',
          marginLeft: '11px',
          padding: '0',
          '& .MuiSvgIcon-root': {
            fontSize: 18,
          },
        },
      },
    },
    MuiRadioGroup: {
      styleOverrides: {
        root: {
          flexDirection: 'row',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C4C4C4',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#003781',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#003781',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontWeight: 400,
          fontSize: '14px',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#D1E8EA',
          color: '#000',
          fontSize: '12px',
          padding: '8px',
        },
      },
    },
  },
});
